import { Typography, styled } from '@mui/material';

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
          color: ${theme.palette.secondary.light}
  `
);

export default UserBoxDescription;
